import React from 'react';
import moment from 'moment';
import TempNameLink from './TempNameLink';
import ActionCell from './ActionCell';

const columns = [
  {
    title: 'Id',
    dataKey: 'id',
    key: 'id',
    width: 50,
  },
  {
    title: 'Name',
    dataKey: 'title',
    key: 'title',
    width: 500,
    cellRenderer: ({ rowData }) => {
      return (
        <TempNameLink {...rowData} />
      );
    },
  },
  {
    title: 'Created At',
    dataKey: 'createTime',
    key: 'createTime',
    width: 300,
    dataGetter: ({ rowData }) => {
      return moment(rowData.createTime).format();
    },
  },
  {
    title: 'Last Accessed At',
    dataKey: 'lastAccessedTime',
    key: 'lastAccessedTime',
    width: 300,
    dataGetter: ({ rowData }) => {
      return rowData.lastAccessedTime ?moment(rowData.lastAccessedTime).format() : '-'
    },
  },
  {
    title: 'Actions',
    dataKey: 'actions',
    key: 'actions',
    width: 200,
    cellRenderer: ({ rowData }) => {
      return <ActionCell {...rowData} />;
    },
  },
];

export default columns;

